import { useState } from 'react'
import { MdKeyboardArrowDown, MdReceipt, MdCancel, MdOpenInFull, MdPersonRemove, MdStarBorder } from 'react-icons/md'
import styles from '../InternalExternalDetail.module.css'

const MENU = [
  { Icon: MdReceipt,      label: 'Move to off billing' },
  { Icon: MdCancel,       label: 'Cancel Contract' },
  { Icon: MdOpenInFull,   label: 'Extend Contract' },
  { Icon: MdPersonRemove, label: 'Terminate Candidate' },
  { Icon: MdStarBorder,   label: 'Rate Candidate' },
]

const HiredStatusHeader = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className={styles.profileHeader}>
        <div className={styles.hiredHeader} onClick={() => setOpen((v) => !v)}>
          <span className={styles.hiredTag}>Hired</span>
          <MdKeyboardArrowDown className={`${styles.chevronIcon} ${open ? styles.chevronOpen : ''}`} />
        </div>
      </div>

      {open && (
        <div className={styles.hiredDropdown}>
          {MENU.map(({ Icon, label }) => (
            <div key={label} className={styles.hiredMenuItem}>
              <Icon className={styles.menuItemIcon} />
              <span>{label}</span>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default HiredStatusHeader
